import type { Messages } from '@/i18n/messages/en/index.ts'
import { activity } from '@/i18n/messages/pt-BR/activity.ts'
import { admin } from '@/i18n/messages/pt-BR/admin/index.ts'
import { approvals } from '@/i18n/messages/pt-BR/approvals.ts'
import { brand } from '@/i18n/messages/pt-BR/brand.ts'
import { chat } from '@/i18n/messages/pt-BR/chat.ts'
import { common } from '@/i18n/messages/pt-BR/common.ts'
import { errors } from '@/i18n/messages/pt-BR/errors/index.ts'
import { feedback } from '@/i18n/messages/pt-BR/feedback.ts'
import { governance } from '@/i18n/messages/pt-BR/governance.ts'
import { groups } from '@/i18n/messages/pt-BR/groups.ts'
import { home } from '@/i18n/messages/pt-BR/home.ts'
import { knowledge } from '@/i18n/messages/pt-BR/knowledge.ts'
import { knowledgeFolders } from '@/i18n/messages/pt-BR/knowledgeFolders.ts'
import { login } from '@/i18n/messages/pt-BR/login.ts'
import { marketplace } from '@/i18n/messages/pt-BR/marketplace/index.ts'
import { memory } from '@/i18n/messages/pt-BR/memory.ts'
import { people } from '@/i18n/messages/pt-BR/people.ts'
import { sharing } from '@/i18n/messages/pt-BR/sharing.ts'
import { shell } from '@/i18n/messages/pt-BR/shell.ts'
import { trace } from '@/i18n/messages/pt-BR/trace.ts'

/** Brazilian Portuguese, checked against the English shape at compile time. */
export const ptBR: Messages = {
  activity,
  admin,
  approvals,
  brand,
  chat,
  common,
  errors,
  feedback,
  governance,
  groups,
  home,
  knowledge,
  knowledgeFolders,
  login,
  marketplace,
  memory,
  people,
  sharing,
  shell,
  trace
}
